<!--
  This replaces StripeCard.vue, and requires Stripe's PaymentIntents API instead
  of the simpler tokens/charges/refunds API that StripeCard.vue relies on

  The benefit is this allows us to add other payment methods easily
-->

<template>
  <div class='errors'>
    <div id='payment-element'>
      <!-- Stripe elements inserts fields here -->
    </div>

    <div v-if='errors.card' class='error'>{{ card_error }}</div>
  </div>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'
  import TotalsMixin from 'app/mixins/TotalsMixin'

  export default {
    mixins: [TotalsMixin],
    props: ['express_checkout', 'order'],
    async mounted() {
      this.stripe = await loadStripe(window.STRIPE_PUBLISHABLE_KEY)
      this.payment_intent = await this.load_payment_intent()
      // console.log(`client secret: ${clientSecret}`)

      const appearance = {
        theme: 'flat',
        variables: {
          fontFamily: '"Roboto Condensed", system-ui, sans-serif',
          fontLineHeight: '1.5',
          borderRadius: '6px',
          colorBackground: '#fff',
          colorPrimaryText: '#262626'
        },
        rules: {
          '.Block': {
            backgroundColor: 'var(--colorBackground)',
            boxShadow: 'none',
            padding: '12px'
          },
          '.Input': {
            padding: '12px',
            border: '1px solid rgb(161, 161, 170)'
          },
          '.Input:disabled, .Input--invalid:disabled': {
            color: 'lightgray'
          },
          '.Tab': {
            padding: '10px 12px 8px 12px',
            border: '1px solid transparent',
            borderRadius: '12px',
            backgroundColor: '#f9f9f9'
          },
          '.Tab:hover': {
            border: '1px solid transparent',
            boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.2), 0px 3px 7px rgba(18, 42, 66, 0.2)'
          },
          '.Tab--selected, .Tab--selected:focus, .Tab--selected:hover': {
            border: '1px solid #323232',
            backgroundColor: '#fff'
          },
          '.Label': {
            fontWeight: '500'
          }
        }
      }

      const options = {
        clientSecret: this.payment_intent.client_secret,
        appearance
      }

      const paymentElementOptions = {
        fields: {
          billingDetails: {
            name: 'never',
            email: 'never',
            // address: {
            //   country: 'never'
            // }
          }
        },
        paymentMethodOrder: ['card', 'klarna'],
        wallets: {
          applePay: 'never',
          googlePay: 'never'
        }
      }

      this.elements = this.stripe.elements(options)
      this.payment_method = this.elements.create('payment', paymentElementOptions)
      this.payment_method.mount('#payment-element')
    },
    data() {
      return {
        errors: {},
        payment_intent: {}
      }
    },
    watch: {
      express_checkout: {
        handler() {
          if (this.express_checkout) {
            this.$set(this.errors, 'card', null)
          }
        },
        immediate: false
      }
    },
    computed: {
      card_error() {
        if (this.errors.card === 'Your postal code is incomplete.') {
          return "Payment method postal code is required (located directly above after your card's CVC)."
        } else {
          return this.errors.card
        }
      }
    },
    methods: {
      uses_payment_intents() {
        return true
      },
      load_payment_intent() {
        return new Promise((resolve, reject) => {
          // first try loading from query params
          // this is only when a klarna payment has failed
          const query_params = new URLSearchParams(window.location.search)
          const payment_intent_id = query_params.get("payment_intent")
          const secret = query_params.get("payment_intent_client_secret")
          if (payment_intent_id && secret) {
            resolve({
              id: payment_intent_id,
              client_secret: secret
            })
          } else {
            // generate a new payment intent
            this.$http.post('/stripe_payment_intents/fetch').then((response) => {
              resolve(response.body)
            }, response => {
              reject(response.body)
            })
          }
        })
      },
      payment_intent_id() {
        if (this.payment_intent) return this.payment_intent.id
      },
      client_secret() {
        if (this.payment_intent) return this.payment_intent.client_secret
      },
      async confirm_payment(order_uid, name, email) {
        // make sure the payment element is up to date with
        // the latest payment intent data
        const {error} = await this.elements.fetchUpdates()

        // confirm the payment
        return this.stripe.confirmPayment({
          elements: this.elements,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: name,
                email: email
              }
            },
            return_url: `${window.location.origin}/orders/${order_uid}/confirm_payment`,
          }
        })
      }
    }
  }
</script>
